












































































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { Color } from '@/models/entities/Color';
import { ColorGroup } from '@/models/entities/ColorGroup';
import PaginatedAutocomplete from '@/components/utils/PaginatedAutocomplete.vue';
import { DropdownFilter } from '@/models/filters/Filters';

interface Props {
  id: string;
}

interface State {
  entity: Color;
  loading: boolean;
}

const Component = defineComponent({
  name: 'ColorDialog',

  components: {
    EntityDialog,
    PaginatedAutocomplete,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let color = new Color({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(`colorsModule/fetchItem`, props.id);
        if (!res) $router.back();
      }
    });

    const state = reactive({
      entity: color,
      loading: computed(() => $store.getters['colorsModule/loading']),
    }) as State;

    const filterDropdown = new DropdownFilter({
      label: 'Color Groups',
      itemsModuleName: 'colorGroupsModule',
      initialValue: state.entity.colorGroups.map(item => item.id),
    });

    watch(
      () => $store.getters['colorsModule/selectedItem'],
      (newValue: Color) => {
        Object.assign(color, newValue);
        filterDropdown.initialValue = state.entity.colorGroups.map(item => item.id);
      },
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Color';
      return `Edit Color`;
    });

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
      hex: [
        (v: string) => !!v || 'HEX is required',
        (v: string) => /^#([0-9A-F]{3}){1,2}$/i.test(v) || 'Hex is invalid',
      ],
      number: [(v: number) => v >= 0 || 'Only positive numbers allowed'],
    };

    function setNewColorGroup(colorGroups: (ColorGroup | number)[]) {
      const newColorGroups: ColorGroup[] = [];
      colorGroups.forEach(colorGroup => {
        if (typeof colorGroup === 'number') {
          const old = state.entity.colorGroups.find(item => item.id === colorGroup);
          if (old) newColorGroups.push(old);
        } else {
          newColorGroups.push(colorGroup);
        }
      });
      state.entity.colorGroups = newColorGroups;
    }

    return {
      state,
      title,
      rules,
      isNew,
      setNewColorGroup,
      filterDropdown,
    };
  },
});
export default Component;
